import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { sameSubmasterId } from './productUtils';

export default function TagInput({
  label,
  selectedIds,
  allItems,
  fieldName,
  onAdd,
  onRemove,
  required,
  errors,
}) {
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredItems = allItems.filter(
    (item) =>
      !selectedIds.some((sid) => sameSubmasterId(sid, item.id)) &&
      item.name.toLowerCase().includes(inputValue.toLowerCase()),
  );

  const handleSelect = (id) => {
    onAdd(fieldName, String(id));
    setInputValue('');
    setShowDropdown(false);
  };

  const inputId = `tag-input-${fieldName}`;

  return (
    <div className="mb-3">
      <label htmlFor={inputId} className="form-label fw-600 label-dark">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="tag-input-wrapper">
        <div className="tag-chip-container">
          {selectedIds.length > 0 ? (
            selectedIds.map((id) => {
              const item = allItems.find((o) => sameSubmasterId(o.id, id));
              return item ? (
                <span key={String(id)} className="tag-chip">
                  {item.name}
                  <button
                    type="button"
                    className="tag-chip-remove"
                    onClick={() => onRemove(fieldName, id)}
                    aria-label={`Remove ${item.name}`}
                  >
                    <FaTimes aria-hidden />
                  </button>
                </span>
              ) : null;
            })
          ) : (
            <small className="text-muted tag-chip-empty">No items selected</small>
          )}
        </div>

        <input
          id={inputId}
          type="text"
          className="form-control form-control-sm"
          placeholder={`Search and add ${label.toLowerCase()}...`}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            setShowDropdown(true);
          }}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        />

        {showDropdown && filteredItems.length > 0 && (
          <ul className="tag-dropdown">
            {filteredItems.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleSelect(item.id);
                  }}
                  className="tag-dropdown-btn"
                >
                  {item.name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      {errors && <div className="invalid-feedback d-block text-error">{errors}</div>}
    </div>
  );
}
